import React, { Component } from 'react';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {  Label } from 'reactstrap';
import CSVIcon from '../Images/csv-ico.png';
import Checkbox from '@material-ui/core/Checkbox';
import JobService  from '../Services/JobService/jobService';
import { css } from 'react-emotion';
import Radio from '@material-ui/core/Radio';
import {  Redirect } from 'react-router-dom';
// First way to import
import { ClipLoader } from 'react-spinners';
import JobsFile from '../Resources/Example of Jobs.csv';
import Select from 'react-select';
var base64 = require('base-64');

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const scrollTable = {
    'height': '100px',
    'overflowY': 'scroll'
}

class JobsImportFile extends Component{

    constructor(props){
        super(props);
        this.state = {
            JobList: { pennding:false, value: []},
            JobUpList: { pennding:false, value: []},
            HeadersList: [],
            error: null,
            checkboxOptions: [],
            CompanyCode: "",
            Selected: false,
            loading: false,
            AddButton: "",
            selectedValue: '2',
            Headers: false,
            HJobCode: false,
            HJobName: false,
            HJobInternal: false,
            HJobInactive: false,
            HJobCategory: false,
            HJobRateAmount: false,
            HJobQuantity: false,
            HJobMarkAsCompleted: false,
            HJobProjectName: false,
            UploadFileName: "Choose File",
            isAutenticated: true
        };
        this.handleData = this.handleData.bind(this);
        this.SelectedAll = this.SelectedAll.bind(this);
        this.onChange = this.onChange.bind(this);
    }  

    handleData(e) {
        var uploadedFile = e.target.files[0];
        var name = e.target.files[0] ?  e.target.files[0].name : "Choose File";
        var extFile = e.target.files[0].name.split('.').pop();

        this.setState({
            JobUpList: { pennding: true,  value: [] },
            HeadersList: [],
            Headers: false
        });             
        if(uploadedFile){
            if(extFile.toUpperCase() !== "CSV")
            {
                toast.error("File has to be a .CSV!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }
        let reader = new FileReader();    
        reader.onload = (progressEvent) => {
            // let target = progressEvent.target; 
            // let result = target.result;               
            var base64result = reader.result.split(',')[1];
            var encoded = base64.decode(base64result);
            var data = encoded.split('\n');
            var DataList = [];
            data.forEach(element => {
                DataList.push(element.split(','));                
            });
            
            var JobCode = "";
            var JobName = "";
            var Internal = "";
            var Inactive = "";
            var Category = "";
            var RateAmount = "";
            var Quantity = "";
            var ProjectName = "";
            var MarkAsCompleted = "";
            DataList[0].forEach(function(element) {

                if(element.replace(/\s/g, "").toUpperCase() === "JOBCODE"){
                    
                    JobCode = element;
                }else if(element.replace(/\s/g, "").toUpperCase() === "JOBNAME"){

                    JobName = element;
                }else if(element.replace(/\s/g, "").toUpperCase() === "INTERNAL"){

                    Internal = element;
                }else if(element.replace(/\s/g, "").toUpperCase() === "INACTIVE"){

                    Inactive = element;
                }else if(element.replace(/\s/g, "").toUpperCase() === "CATEGORY"){

                    Category = element;
                }else if(element.replace(/\s/g, "").toUpperCase() === "RATEAMOUNT"){

                    RateAmount = element;
                }else if(element.replace(/\s/g, "").toUpperCase() === "QUANTITY"){

                    Quantity = element;
                }else if(element.replace(/\s/g, "").toUpperCase() === "PROJECTNAME"){

                    ProjectName = element;
                }else if(element.replace(/\s/g, "").toUpperCase() === "MARKASCOMPLETED"){

                    MarkAsCompleted = element;
                }
                

              });
            this.setState({
                JobUpList: { pennding: true, value: DataList},
                HeadersList: DataList[0],
                Headers: true,
                UploadFileName: name,
                HJobCode: {value: JobCode, label:JobCode},
                HJobName: {value: JobName, label:JobName},
                HJobInternal: {value: Internal, label:Internal},
                HJobInactive: {value: Inactive, label:Inactive},
                HJobCategory: {value: Category, label:Category},
                HJobRateAmount: {value: RateAmount, label:RateAmount},
                HJobQuantity: {value: Quantity, label:Quantity},
                HJobProjectName: {value: ProjectName, label:ProjectName},
                HJobMarkAsCompleted: {value: MarkAsCompleted, label:MarkAsCompleted}
            });    
          };    
          reader.readAsDataURL(uploadedFile); 
        }else{
            this.setState({
                JobUpList: { pennding: true, value: []},
                HeadersList: [],
                Headers: true,
                UploadFileName: "Choose File"
            });   
        } 
    }
    handleHJobCode = event => {
        this.setState({
            HJobCode: event
        });
    }
    handleHJobName = event => {
        this.setState({
            HJobName: event
        });
    }
    handleHJobInternal = event => {
        this.setState({
            HJobInternal: event
        });
    }
    handleHJobInactive = event => {
        this.setState({
            HJobInactive: event
        });
    }
    handleHJobCategory = event => {
        this.setState({
            HJobCategory: event
        });
    }
    handleHJobRateAmount = event => {
        this.setState({
            HJobRateAmount: event
        });
    }
    handleHJobQuantity = event => {
        this.setState({
            HJobQuantity: event
        });
    }
    handleHJobMarkAsCompleted = event => {
        this.setState({
            HJobMarkAsCompleted: event
        });
    }
    handleHJobProjectName = event => {
        this.setState({
            HJobProjectName: event.target.value
        });
    }
    handleChange = event => {  

        this.setState({
            selectedValue: event.target.value,
            JobList: { pennding: false, value: [] }
       });  
    }
    UploadLocationList(e) {
        e.preventDefault();

        var ActionType = this.state.selectedValue;
        var DataList = this.state.JobUpList.value;
        var HeaderListist = this.state.HeadersList;
        var HeaderJobCode = this.state.HJobCode.value;
        var HeaderJobName = this.state.HJobName.value;
        var HeaderJobInternal = this.state.HJobInternal.value;
        var HeaderJobInactive = this.state.HJobInactive.value;
        var HeaderJobCategory = this.state.HJobCategory.value;
        var HeaderJobRateAmount = this.state.HJobRateAmount.value;
        var HeaderJobQuantity = this.state.HJobQuantity.value;
        var HeaderJobMarkAsCompleted = this.state.HJobMarkAsCompleted.value;
        var HeaderJobProjectName = this.state.HJobProjectName.value;
        var Result = [];

        var positionJobCode = HeaderListist.indexOf(HeaderJobCode);
        var positionJobName = HeaderListist.indexOf(HeaderJobName);
        var positionJobInternal = HeaderListist.indexOf(HeaderJobInternal);
        var positionJobInactive = HeaderListist.indexOf(HeaderJobInactive);
        var positionJobCategory = HeaderListist.indexOf(HeaderJobCategory);
        var positionJobRateAmount = HeaderListist.indexOf(HeaderJobRateAmount);
        var positionJobQuantity = HeaderListist.indexOf(HeaderJobQuantity);
        var positionJobMarkAsCompleted = HeaderListist.indexOf(HeaderJobMarkAsCompleted);
        var positionJobProjectName = HeaderListist.indexOf(HeaderJobProjectName);

        if (positionJobCode === -1) {
            toast.error("Job Code field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }       
        if (positionJobName === -1) {
            toast.error("Job Name field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionJobInternal === -1) {
            toast.error("Job Internal field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionJobInactive === -1) {
            toast.error("Job Inactive field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        var Category = "";
        var RateAmount = "";
        var Quantity = "";
        var MarkAsCompleted = "";
        var ProjectName = "";
        for (var i = 1; i < (DataList.length - 1); i++) {

            if (DataList[i] !== "") {

                if(positionJobCategory === -1)
                   Category = "";
                else
                   Category =  DataList[i][positionJobCategory];  


                if(positionJobRateAmount === -1)
                   RateAmount = "";
                else
                   RateAmount =  DataList[i][positionJobRateAmount];  

                if(positionJobQuantity === -1)
                    Quantity = "";
                else
                    Quantity =  DataList[i][positionJobQuantity];  

                if(positionJobMarkAsCompleted === -1)
                    MarkAsCompleted = "";
                else
                    MarkAsCompleted =  DataList[i][positionJobMarkAsCompleted]; 
                    
                if(positionJobProjectName === -1)
                    ProjectName = "";
                else
                    ProjectName =  DataList[i][positionJobProjectName]; 

                  
                Result.push({ CODE: DataList[i][positionJobCode], NAME : DataList[i][positionJobName],TA_HOURLY_RATE: RateAmount, 
                              INTERNAL: DataList[i][positionJobInternal], QUANTITY: Quantity, INACTIVE : DataList[i][positionJobInactive],
                              CATEGORY: Category, CONFIRMATION_REQUIRED: MarkAsCompleted, PROJECT_NAME: ProjectName });
            }
        } 
        if(DataList === "" || DataList === null || DataList === undefined || DataList.length === 0){ 
            toast.error("You must to select a File!", { className: {
                opacity: 0.8
            }}); 
        }else{ 
            if(this.props.CompanyCode && DataList){ 
                this.setState({
                    JobList: { pennding: true, value: [] }
                });      
                var ListResult =  JobService.getJobListResult(this.props.CompanyCode, Result, ActionType); 
                var that = this; 
                ListResult.then(function (data) { 
                    if(data.statusText === "OK")
                    {                
                        that.setState({
                            JobList: { pennding: false, value: data.data },
                            checkboxOptions: []
                        });
                    }
                }).catch((error) => {                       
                    that.setState({
                        JobList: { pennding: false, value: [] },
                        checkboxOptions: [],
                    });
                    if(error.response)
                    {
                        if(error && error.response && error.response.data.Message === "500") {               
                            toast.error("Error Data Base(Error: 500)", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data === "NoDB") {
                           toast.error("Company Code dosen't exist!", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data === "NotReseller") {    
                           toast.error("This User does not have permission!", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data.Message === "400"){ 
                           toast.error("API Error for Reseller", { className: {
                               opacity: 0.8
                           }});
                        }else if(error.response.status === 401){ 
                               sessionStorage.setItem("user", '');
                               sessionStorage.setItem("token", '');
                               sessionStorage.setItem("rol", '');
                               sessionStorage.setItem("email", '');
                               sessionStorage.clear();  
                               this.setState({ isAutenticated: false },
                               ()=>{                               
                                   this.forceUpdate();
                               })              
                        }   
                    }else{
                        toast.error("Code Error", { className: {
                            opacity: 0.8
                        }});
                    }
                });
            }  
        }
    }
    onChange(e, code) {     
        const options = this.state.checkboxOptions
        let index;    
        if (!options.find(x=>x===code)) {
          options.push(code)
        } else {
          index = options.indexOf(code)
          options.splice(index, 1)
        }
        this.setState({ checkboxOptions: options }, console.log())
    }
    SelectedAll(e){
        if(e.target.checked){
            let optionChecked = [];
             this.state.JobList.value.forEach(l=>{
                  if(l.AVAILABLE)
                  optionChecked.push(l.CODE);
             })
             this.setState({checkboxOptions:optionChecked})
        }
        else{
            this.setState({checkboxOptions:[]})
        }          
    }
    SaveJobList(e){
        e.preventDefault();
        var CheckboxList = this.state.checkboxOptions; 
        var email = sessionStorage.getItem('email');
        var ActionType = this.state.selectedValue;
        var result = [];  
        var that = this; 
        that.setState({
            loading: true,
            AddButton: "disabled"
        });
        if(CheckboxList.length === 0 || ActionType === "" || ActionType === undefined || ActionType === null)
        {
            toast.error("You must to select a Job and Option Rows!", { className: {
                opacity: 0.8
            }});            
            that.setState({
                loading: false,
                AddButton: ""
            });
        }else{
            CheckboxList.forEach(l =>{ var job = this.state.JobList.value.find(x=>x.CODE === l);
               result.push(job);
           });
           var DataResult = JobService.SaveJob(this.props.CompanyCode, result, ActionType, email);
           DataResult.then(function (data) {
               if(data.data === "OK")
               {                
                   that.setState({
                       loading: false,
                       JobList: { pennding: false, value: [] },
                       checkboxOptions: [],
                       AddButton: "",
                       CompanyCode: "",
                   });
                   toast.success("Jobs Saved!", { className: {
                       opacity: 0.8
                   }});
               }else if(data.statusText === "No")
               {                
                   that.setState({
                       loading: false,
                       JobList: { pennding: false, value: [] },
                       checkboxOptions: [],
                       AddButton: "",
                       CompanyCode: "",
                   });
                   toast.error("No Saved!", { className: {
                       opacity: 0.8
                   }});
               }else if(data.statusText === "AuditError")
               {                
                   that.setState({
                       loading: false,
                       JobList: { pennding: false, value: [] },
                       checkboxOptions: [],
                       AddButton: "",
                       CompanyCode: "",
                   });
                   toast.error("No Saved!", { className: {
                       opacity: 0.8
                   }});
               }else if(data.data === "InUse")
               {                
                    that.setState({
                        loading: false,
                        JobList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                   toast.error("Position Code in Use!", { className: {
                       opacity: 0.8
                   }});
               }
           }).catch((error) => {  
                
                that.setState({
                loading: false,
                JobList: { pennding: false, value: [] },
                checkboxOptions: [],
                AddButton: "",
                CompanyCode: "",
                });
                if(error.response)
                {
                    if(error && error.response && error.response.data.Message === "500") {               
                        toast.error("Error Data Base(Error: 500)", { className: {
                           opacity: 0.8
                       }});
                   }else if(error && error.response && error.response.data === "NoDB") {
                       toast.error("Company Code dosen't exist!", { className: {
                           opacity: 0.8
                       }});
                   }else if(error && error.response && error.response.data === "NotReseller") {    
                       toast.error("This User does not have permission!", { className: {
                           opacity: 0.8
                       }});
                   }else if(error && error.response && error.response.data.Message === "400"){ 
                       toast.error("API Error for Reseller", { className: {
                           opacity: 0.8
                       }});
                    }else if(error.response.status === 401){ 
                           sessionStorage.setItem("user", '');
                           sessionStorage.setItem("token", '');
                           sessionStorage.setItem("rol", '');
                           sessionStorage.setItem("email", '');
                           sessionStorage.clear();  
                           this.setState({ isAutenticated: false },
                           ()=>{                               
                               this.forceUpdate();
                           })              
                    }   
                }else{
                    toast.error("Code Error", { className: {
                        opacity: 0.8
                    }});
                }
           });
        }       
    }
    changeName(e){
        //alert(e.target.value)
        var str = e.target.value;
        var res = str.substring(12)
        var extention = res.split('.').pop();

        if(extention.toUpperCase() === "CSV")
        {
            this.setState({
                FileName: res 
            });
        }else{
            this.setState({
                FileName: "CHOOSE A FILE",
                JobUpList: { pennding: false, value: [] },
            });
            toast.error("File Error!", { className: {
                opacity: 0.8
            }});
            return false;
        }  
        return true;     
    }
    render(){              
       
        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }

        let optionItemsHeaders = this.state.HeadersList.map((item, index) => {
            return { value: item, label: item}
        });

        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body">
                    <div className="row">
                        <div className="col-2">
                            <h4><span className="badge badge-info">Jobs</span></h4>
                        </div>                           
                        <div className="col-2 offset-10">
                            <Label for="exampleFile" style={{ 'fontWeight': 'bold' }}>Download Sample</Label>
                            <a href={JobsFile} download="Example of Jobs.CSV"><img src={CSVIcon} title="NotImage" alt="" width='40px' /></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 offset-2">
                            {
                                this.props.CompanyCode
                                &&
                                <div className="upload-btn-wrapper" key={Math.random()*1200000}>
                                    <button style={{ 'width' : '100%', 'backgroundColor': '#00C851', 'marginLeft': '0px'}} onClick={(e)=>this.fileInput.click(e)}  className="btn btn-primary">{this.state.UploadFileName}</button>
                                    <input  ref={input =>this.fileInput = input } type="file" name="myfile" style={{'display': 'none'}}  onChange={ (event)=>{this.handleData(event)}}/>                                   
                                </div>
                            }
                        </div>
                        <div className="col-2">
                            {
                                this.props.CompanyCode
                                &&
                                <div >
                                    <label>Delete Rows in Table</label>
                                    <Radio
                                        checked={this.state.selectedValue === '1'}
                                        onChange={this.handleChange}
                                        value="1"
                                        name="radio-button-demo"
                                        aria-label="A"
                                        color="primary"
                                    />
                                </div>
                            }
                        </div>
                        <div className="col-3">
                            {
                                this.props.CompanyCode
                                &&
                                <div >
                                    <label>Appends Rows in Table</label>
                                    <Radio
                                        checked={this.state.selectedValue === '2'}
                                        onChange={this.handleChange}
                                        value="2"
                                        name="radio-button-demo"
                                        aria-label="B"
                                        color="primary"
                                    />
                                </div>
                            }
                        </div>

                    </div>
                    <br /> <br />
                        {
                            this.state.Headers
                            &&
                            <div className="row">
                                <div className="col-2">
                                        <div className="form-group">
                                            <label style={{ 'fontWeight': '900',display: "inline-block" }} className="">Job Code(<span style={{color: 'red'}}>*</span>):</label>
                                            <Select
                                                value={this.state.HJobCode}
                                                onChange={this.handleHJobCode}
                                                options={optionItemsHeaders}
                                                styles={{  width: "10px"}}
                                            />
                                        </div>
                                </div>
                                <div className="col-2">
                                        <div className="form-group">
                                            <label style={{ 'fontWeight': '900',display: "inline-block" }} className="">Job Name(<span style={{color: 'red'}}>*</span>):</label>
                                            <Select
                                                value={this.state.HJobName}
                                                onChange={this.handleHJobName}
                                                options={optionItemsHeaders}
                                                styles={{  width: "10px"}}
                                            />
                                        </div>
                                </div>
                                <div className="col-2">
                                        <div className="form-group">
                                            <label style={{ 'fontWeight': '900',display: "inline-block" }} className="">Internal(<span style={{color: 'red'}}>*</span>):</label>
                                            <Select
                                                value={this.state.HJobInternal}
                                                onChange={this.handleHJobInternal}
                                                options={optionItemsHeaders}
                                                styles={{  width: "10px"}}
                                            />
                                        </div>
                                </div>
                                <div className="col-2">
                                        <div className="form-group">
                                            <label style={{ 'fontWeight': '900',display: "inline-block" }} className="">Inactive(<span style={{color: 'red'}}>*</span>):</label>
                                            <Select
                                                value={this.state.HJobInactive}
                                                onChange={this.handleHJobInactive}
                                                options={optionItemsHeaders}
                                                styles={{  width: "10px"}}
                                            />
                                        </div>
                                </div>
                                <div className="col-2">
                                        <div className="form-group">
                                            <label style={{ 'fontWeight': '900',display: "inline-block" }} className="">Category(<span style={{color: 'red'}}>*</span>):</label>
                                            <Select
                                                value={this.state.HJobCategory}
                                                onChange={this.handleHJobCategory}
                                                options={optionItemsHeaders}
                                                styles={{  width: "10px"}}
                                            />
                                        </div>
                                </div>                               
                            </div>
                        }
                        {
                            this.state.Headers
                            &&
                            <div className="row">
                                <div className="col-2">
                                            <div className="form-group">
                                                <label style={{ 'fontWeight': '900',display: "inline-block" }} className="">Rate Amount</label>
                                                <Select
                                                    value={this.state.HJobRateAmount}
                                                    onChange={this.handleHJobRateAmount}
                                                    options={optionItemsHeaders}
                                                    styles={{  width: "10px"}}
                                                />
                                            </div>
                                    </div>
                                    <div className="col-2">
                                            <div className="form-group">
                                                <label style={{ 'fontWeight': '900',display: "inline-block" }} className="">Quantity</label>
                                                <Select
                                                    value={this.state.HJobQuantity}
                                                    onChange={this.handleHJobQuantity}
                                                    options={optionItemsHeaders}
                                                    styles={{  width: "10px"}}
                                                />
                                            </div>
                                    </div>
                                    <div className="col-2">
                                            <div className="form-group">
                                                <label style={{ 'fontWeight': '900',display: "inline-block" }} className="">Mark As Completed</label>
                                                <Select
                                                    value={this.state.HJobMarkAsCompleted}
                                                    onChange={this.handleHJobMarkAsCompleted}
                                                    options={optionItemsHeaders}
                                                    styles={{  width: "10px"}}
                                                />
                                            </div>
                                    </div>
                                    <div className="col-2">
                                            <div className="form-group">
                                                <label style={{ 'fontWeight': '900',display: "inline-block" }} className="">Project Name</label>
                                                <Select
                                                    value={this.state.HJobProjectName}
                                                    onChange={this.handleHJobProjectName}
                                                    options={optionItemsHeaders}
                                                    styles={{  width: "10px"}}
                                                />
                                            </div>
                                    </div>
                                    <div className="col-2 offset-2" style={{ paddingTop:"30px"}}>
                                        <button className="btn btn-info" onClick={(e) => { this.UploadLocationList(e) }} >Preview</button>
                                    </div>
                            </div>
                        }
                    </div>
                </div>
                    {
                        (this.state.JobList.pennding
                        && <span className="loader"></span>)
                        ||
                        (this.state.JobList.value.length > 0 
                        && <div className="card Logs">
                             <div className="card-body">
                             <div className="row" style={{'height': '350px', 'overflow': 'auto'}}>
                                <table className="table table-hover table-striped table-sm" >
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                    <Checkbox
                                                        style={{ width: 25, height: 25 }}
                                                        // checked={this.state.Selected}
                                                        onChange={this.SelectedAll}
                                                        //value={this.state.checkboxOptions}
                                                        color="primary"
                                                        />
                                                    </th>
                                                    <th scope="col">Code</th>
                                                    <th scope="col">Name</th>     
                                                    <th scope="col">Internal</th> 
                                                    <th scope="col">Inactive</th> 
                                                    <th scope="col">Category</th> 
                                                    <th scope="col">Rate Amount</th> 
                                                    <th scope="col">Quantity</th> 
                                                    <th scope="col">Mark As Completed</th> 
                                                    <th scope="col">Project Name</th>                                           
                                                </tr>
                                            </thead>
                                            <tbody style={scrollTable}>
                                                {
                                                    (this.state.JobList.pennding
                                                    && <tr><td colSpan="7"><span className="loader"></span></td></tr>)
                                                    || this.state.JobList.value.map((item, index) => {
                                                        
                                                        return <tr key={index}>
                                                            <td>
                                                                {
                                                                    (item.AVAILABLE 
                                                                    && 
                                                                        <Checkbox
                                                                        style={{ width: 25, height: 25 }}
                                                                        checked={this.state.checkboxOptions.find(x=>x === item.CODE)!== undefined }
                                                                        onChange={(e)=>this.onChange(e,item.CODE)}
                                                                        value= {item.CODE}
                                                                        color="primary"
                                                                     />)
                                                                     || 
                                                                      <span className="badge badge-danger">{item.AVAILABLE_MSG}</span>
                                                                }
                                                               
                                                            </td>
                                                            <td>{item.CODE}</td>
                                                            <td>{item.NAME}</td>
                                                            <td>{item.INTERNAL}</td>
                                                            <td>{item.INACTIVE}</td>
                                                            <td>{item.CATEGORY}</td>
                                                            <td>{item.TA_HOURLY_RATE}</td>
                                                            <td>{item.QUANTITY}</td>
                                                            <td>{item.CONFIRMATION_REQUIRED}</td>
                                                            <td>{item.PROJECT_NAME}</td>
                                                        </tr>;
                                                    })
                                                }
                                            </tbody>
                                    </table>                                     
                                </div>
                                <div className="row">
                                    <div className="col-2 offset-10">
                                        <ClipLoader
                                            className={override}
                                            sizeUnit={"px"}
                                            size={30}
                                            color={'#33B5E5'}
                                            loading={this.state.loading}
                                        />                                        
                                        <button disabled={this.state.AddButton} className="btn btn-info" onClick={(e)=>{this.SaveJobList(e)}} >Save</button>
                                    </div>
                                </div>                                                              
                             </div>
                        </div>  )  
                    }    
            </div>            
        );
    }
}

export default JobsImportFile;


// WEBPACK FOOTER //
// ./src/ImportFile/JobsImportfile.jsx